export default "__VITE_ASSET__a9356c50__"